<template>
  <div class="age-distribution-list-filter">
    <hl-Datepicker name="evenDate" label="Til og med" v-model="evenDate" />
  </div>
</template>

<script>
import FilterMixin from '@/components/reports/filters/FilterMixin';
import moment from 'moment';
import Datepicker from '@modules/husleie-framework/src/components/forms/inputs/Datepicker.vue';

export default {
  name: 'AgeDistributedFilter',

  components: {
    'hl-Datepicker': Datepicker,
  },

  mixins: [FilterMixin],

  computed: {
    evenDate: {
      get() {
        return this.getRemoteSubValueOrDefault('evenDate', moment().format('YYYY-MM-DD'));
      },
      set(v) {
        this.setRemoteValue('evenDate', v);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.age-distribution-list-filter {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 300px));
  grid-gap: 1.25rem;
}
</style>
